export default __webpack_public_path__ + "static/media/SJA1490.34I-42075_-25220_0.8e07ba42.jpg";